import { render } from "./not-found.vue?vue&type=template&id=38a0687c"
import script from "./not-found.vue?vue&type=script&lang=js"
export * from "./not-found.vue?vue&type=script&lang=js"
script.render = render

export default script